import React, { Component } from 'react';
import ReactCountdownClock  from 'react-countdown-clock';
import './css/triviaPanel.css';
import QuestionList from './questionList';
import PlayPause from './playPause'
import ReportModal from './reportModal'

class TriviaPanel extends Component {
  static ShowSkipButton = 0
  static IsSkipping = 1

  constructor (props) {
    super(props)
    this.handleSubmitAnswer = this.handleSubmitAnswer.bind(this)
    this.onQuestionTimerFinish = this.onQuestionTimerFinish.bind(this)
    this.onAnswerTimerFinish = this.onAnswerTimerFinish.bind(this)
    this.stopAnswerDisplay = this.stopAnswerDisplay.bind(this)
    this.skipQuestion = this.skipQuestion.bind(this)
    this.onAnswerPause = this.onAnswerPause.bind(this)
    this.onAnswerPauseToggle = this.onAnswerPauseToggle.bind(this)
    this.onAnswerSelected = this.onAnswerSelected.bind(this)
    this.renderAnswerInput = this.renderAnswerInput.bind(this)

    this.reportModal = React.createRef();
    
    var duration = props.questionList[props.questionList.length - 1]['whenToShowMs'];
    this.answerTimer = 0;
    this.state = {
      inputValue: '',
      questionTimerActive: false,
      shouldShowAnswer: false,
      answerList: [],
      questionTimerDuration: duration,
      fullQuestionList: this.props.questionList,
      skippingState: TriviaPanel.ShowSkipButton,
      previousSubmittedAnswer: '',
      isCorrectAnswer: true,
      answerTimerActive: false,
      answerTimerDuration: 0,
      pauseAnswer: false,
      selectedAnswer: '',
      answerChoices: this.props.answerChoices
    };
  }

  skipQuestion() {
    if (this.state.skippingState === TriviaPanel.ShowSkipButton) {
      this.props.onSkipQuestion()
      this.setState(
        {
          skippingState: TriviaPanel.IsSkipping,
          questionTimerActive: false, 
          questionTimerDuration: 0
        })
    }
  }

  handleSubmitAnswer(event) {
    event.preventDefault()
    var answer = this.state.inputValue
    this.setState({inputValue: '', previousSubmittedAnswer: answer})
    if (!this.state.questionTimerActive) {
      return;
    }
    this.props.onAnswerSubmit(answer)
  }

  componentWillReceiveProps(nextProps) {
    // You don't have to do this check first, but it can help prevent an unneeded render
    if (nextProps.questionList !== this.state.fullQuestionList) {
      var timerDuration = nextProps.questionList[nextProps.questionList.length - 1]['whenToShowMs'];
      this.setState({ 
        fullQuestionList: nextProps.questionList,
        questionTimerActive: true, 
        questionTimerDuration: timerDuration,
        skippingState: TriviaPanel.ShowSkipButton,
      })
    }
    if (nextProps.answerChoices !== this.state.answerChoices) {
      var choices = (nextProps.answerChoices === undefined) ? [] : nextProps.answerChoices
      this.setState({ 
        answerChoices: choices,
        selectedAnswer: ''
      })
    }
    if (nextProps.isCorrectAnswer !== this.props.isCorrectAnswer && nextProps.isCorrectAnswer) {
      this.onQuestionTimerFinish()
    }
  }

  componentDidMount() {
    this.setState({ questionTimerActive: true })
  }

  componentWillUnmount() {
    if (this.timer !== 0) {
      clearTimeout(this.answerTimer)
    }
  }

  onQuestionTimerFinish() {
    if (!this.state.questionTimerActive) {
      return;
    }
    this.setState({questionTimerActive: false, questionTimerDuration: 0 })
    this.props.onQuestionFinished()
  }

  onAnswerTimerFinish() {
    if (!this.state.answerTimerActive) {
      return;
    }
    
    this.setState({answerTimerActive: false, answerTimerDuration: 0 })
    this.stopAnswerDisplay()
  }

  showAnswer(answer) {
    this.setState({answerList: answer, shouldShowAnswer: true})
  }

  startAnswerDisplayTimer(durationInMs) {
    this.setState({answerTimerActive: true, answerTimerDuration: durationInMs})
  }

  stopAnswerDisplay() {
    this.setState({shouldShowAnswer: false})
    this.props.onAnswerFinished()
  }

  onAnswerPauseToggle() {
    if (this.state.shouldShowAnswer) {
      this.setState({pauseAnswer: !this.state.pauseAnswer})
    }
  }

  onAnswerPause() {
    if (this.state.shouldShowAnswer && !this.state.pauseAnswer) {
      this.setState({pauseAnswer: true})
    }
  }

  updateInputValue(evt) {
    this.setState({
      inputValue: evt.target.value
    });
  }

  onAnswerSelected(event) {
    if (!this.state.questionTimerActive || this.state.selectedAnswer !== '') {
      return;
    }
    this.setState({
      selectedAnswer: event, previousSubmittedAnswer: event
    })
    this.props.onAnswerSubmit(event)
  }

  renderAnswerInput() {
    if (this.state.answerChoices == null) {
      return (
        <div>
          <form className="commentFormWeb" onSubmit={this.handleSubmitAnswer}>
            < input type="text" 
              placeholder = "Input answer" 
              className = "Text-Input"
              value={this.state.inputValue}
              ref={input => input && input.focus()}
              onChange={evt => this.updateInputValue(evt)}/>
          </form>
          <form className="commentFormMobile" onSubmit={
            (e) => {
              this.inputRef.blur();
              this.handleSubmitAnswer(e)
            }}>
            < input type="text" 
              placeholder = "Input answer small" 
              className = "Text-Input"
              value={this.state.inputValue}
              ref={ref => this.inputRef = ref}
              onChange={evt => this.updateInputValue(evt)}/>
          </form>
        </div>
        ) 
      } else {
        const answerChoices = this.state.answerChoices.map((possibleAnswer, i) =>
          {
            var buttonClass = "neutral-choice"
            if (this.state.shouldShowAnswer && possibleAnswer === this.state.selectedAnswer) {
              if (this.props.isCorrectAnswer) {
                buttonClass = "correct-choice"
              } else {
                buttonClass = "wrong-choice"
              }
            }
            
            return <button 
                      key={possibleAnswer} 
                      onClick={() => this.onAnswerSelected(possibleAnswer)}
                      className = {buttonClass}>{possibleAnswer}
                    </button>
          }
        );
        return (
          <div key = {this.props.questionNumber} className="choices-group">
            {answerChoices}
          </div>
        )
      }
            
  }

  render() {
    const questionList = this.props.questionList
    const shouldShowAnswer = this.state.shouldShowAnswer
    const questionTimerDuration = this.state.questionTimerDuration / 1000.0
    const answerDescription = this.state.answerChoices == null ? 
      "The answer is" : "The answer is"
    const answerTimerDuration = this.state.answerTimerDuration / 1000.0
    const answerList = [this.state.answerList.map((answer, i) =>
      <li key={answer} className="Question-text">{answer}</li>
    )[0]];

    return (
      <div className = "Container">
        <div className = "Left-Margin"/>
        <div className = "Left-Container">
          <div className = "InfoTimerContainer">
            <div className = "InfoBox">
              <p className = "InfoBoxContent">{this.props.userId}</p>
              <p className = "InfoBoxContent">{this.props.numCorrect}/{this.props.questionNumber} correct</p>
              <div className = "InfoBoxButtonWrapper">
                <ReportModal
                  roomId = {this.props.roomId}
                  userId = {this.props.userId}
                  openAction = {this.onAnswerPause}
                  ref = {this.reportModal}
                />
                <button className="questionControlButton" onClick={this.skipQuestion}
                  disabled = {this.state.skippingState !== TriviaPanel.ShowSkipButton || shouldShowAnswer}>
                    <span>Skip</span>
                </button>
              </div>
            </div>
            <div className = "Clock-Container">
              <ReactCountdownClock seconds={questionTimerDuration}
                paused = {false}
                       color="#000"
                       alpha={0.9}
                       size={100}
                       onComplete={this.onQuestionTimerFinish} /></div>
          </div>

          <div className="questionControlButtonGroup">
            {this.renderAnswerInput()}
            
          </div>

          <div className="answerDiv">
            {
              this.props.showIncorrectAnswer && 
              this.state.answerChoices == null && // not multiple choice
              <div className="IncorrectText">
                <p>{this.state.previousSubmittedAnswer} is incorrect</p>
              </div>
            }

            {
              this.props.isCorrectAnswer && 
              this.state.answerChoices == null && // not multiple choice
              <div className="Question">
                <p>{this.state.previousSubmittedAnswer} is correct</p>
              </div>
            }

            {
              shouldShowAnswer && 
              <PlayPause
                onClick = {this.onAnswerPauseToggle}
                isPaused = {this.state.pauseAnswer}
              />
            }

            {
              shouldShowAnswer && 
              <div className="Question">
                <p>{answerDescription}</p>
                <ul className = "Answer-List">{answerList}</ul>
              </div>
            }
            {
              <ReactCountdownClock seconds={answerTimerDuration}
                paused = {this.state.pauseAnswer}
                       color="#000"
                       alpha={0.0}
                       size={10}
                       onComplete={this.onAnswerTimerFinish} />
            }
            </div>

          </div>
          <div className = "Right-Container">
            <QuestionList questionList = {questionList}></QuestionList>
            <div className="answerDivBottom">
              {
                this.props.showIncorrectAnswer && 
                this.state.answerChoices == null && // not multiple choice
                <div className="IncorrectText">
                  <p>{this.state.previousSubmittedAnswer} is incorrect</p>
                </div>
              }

              {
                this.props.isCorrectAnswer && 
                this.state.answerChoices == null && // not multiple choice
                <div className="Question">
                  <p>{this.state.previousSubmittedAnswer} is correct</p>
                </div>
              }

              {
                shouldShowAnswer && 
                <PlayPause
                  onClick = {this.onAnswerPauseToggle}
                  isPaused = {this.state.pauseAnswer}
                />
              }

              {
                shouldShowAnswer && 
                <div className="Question">
                  <p>{answerDescription}</p>
                  <ul className = "Answer-List">{answerList}</ul>
                </div>
              }
            </div>
          </div>
          <div className = "Right-Margin"/>
        </div>
      );
  }
}

export default TriviaPanel;



// WEBPACK FOOTER //
// ./src/components/triviaPanel.js